import React from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // No longer using old opt-in system - the new waitlist system handles this in App.tsx
  // Simply render children since access control is now handled by the waitlist landing page
  return <>{children}</>;
};

export default ProtectedRoute;
